import hangingCoffins from '../img/places/hanging-coffins-sagada.jpg';
import queenMary from '../img/places/queen-mary.jpg';
import christAbyss from '../img/places/christ-of-the-abyss.jpg';
import clononyCastle from '../img/places/clonony-castle.webp';
import willardAsylum from '../img/places/willard-asylum.jpg';
import nevadaCountyHospital from '../img/places/nevada-county-hospital.jpg';
import rollingHillsAsylum from '../img/places/rolling-hills-asylum.jpg';
import hoThuyTien from '../img/places/ho-thuy-tien.jpg';
import kentMasonicTemple from '../img/places/kent-masonic-temple.jpg';
import skullChapel from '../img/places/skull-chapel.jpg';
import transAllegheny from '../img/places/trans-allegheny-asylum.jpg';
import aokigaharaForest from '../img/places/aokigahara-forest.jpg';
import chernobyl from '../img/places/chernobyl.jpg';
import islandOfTheDolls from '../img/places/island-of-the-dolls.png';
import catacombsParis from '../img/places/catacombs-paris.jpg';
import whaleyHouse from '../img/places/whaley-house.jpg';
import batesMansion from '../img/places/bates-mansion.jpg';
import alcatraz from '../img/places/alcatraz.jpg';
import devilsTower from '../img/places/devils-tower.jpg';
import winchesterHouse from '../img/places/winchester-mystery-house.jpg';


const imageMap = {
    'hanging-coffins-sagada.jpg': hangingCoffins,
    'queen-mary.jpg': queenMary,
    'christ-of-the-abyss.jpg': christAbyss,
    'clonony-castle.webp': clononyCastle,
    'willard-asylum.jpg': willardAsylum,
    'nevada-county-hospital.jpg': nevadaCountyHospital,
    'rolling-hills-asylum.jpg': rollingHillsAsylum,
    'ho-thuy-tien.jpg': hoThuyTien,
    'kent-masonic-temple.jpg': kentMasonicTemple,
    'skull-chapel.jpg': skullChapel,
    'trans-allegheny-asylum.jpg': transAllegheny,
    'aokigahara-forest.jpg': aokigaharaForest,
    'chernobyl.jpg': chernobyl,
    'island-of-the-dolls.png': islandOfTheDolls,
    'catacombs-paris.jpg': catacombsParis,
    'whaley-house.jpg': whaleyHouse,
    'bates-mansion.jpg': batesMansion,
    'alcatraz.jpg': alcatraz,
    'devils-tower.jpg': devilsTower,
    'winchester-mystery-house.jpg': winchesterHouse,
  };


  export default imageMap;